<template>
  <div>
    <Button
      class="mx-2 max-w-2"
      :disabled="current === 1"
      @click="handleChangePage(1)"
    >
      <Icon name="angle-left" />
    </Button>

    <Button
      v-if="offset !== 0"
      class="mx-2 min-w-1 max-w-2"
      @click="handleChangeOffset(-1)"
    >
      <Icon name="angle-double-left" />
    </Button>
    <Button
      class="mx-2 min-w-1 max-w-2"
      v-for="i in limit > total ? total : limit"
      :key="i + offset"
      :color="buttonColor(i + offset)"
      @click="handleChangePage(i + offset)"
    >
      {{ i + offset }}
    </Button>
    <Button
      v-if="offset + limit < total"
      class="mx-2 min-w-1 max-w-2"
      @click="handleChangeOffset(1)"
    >
      <Icon name="angle-double-right" />
    </Button>
    <Button
      class="mx-2 min-w-1 max-w-2"
      :disabled="current === total"
      @click="handleChangePage(total)"
    >
      <Icon name="angle-right" />
    </Button>
  </div>
</template>
<script>
import Button from '../Button';
import Icon from '../Icon';

export default {
  name: 'Pagination',

  components: {Button, Icon},
  data() {
    return {
      offset: 0,
    };
  },

  props: {
    current: {
      type: Number,
      default: 1,
    },

    limit: {
      type: Number,
      default: 5,
    },

    total: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    handleChangeOffset(value) {
      const newOffset = this.offset + value * this.limit;
      if (newOffset < 0) {
        this.offset = 0;
      } else {
        if (newOffset + this.limit > this.total) {
          this.offset = this.total - this.limit
        } else {
          this.offset = newOffset;
        }
      }
    },
    handleChangePage(value) {
      if (value === this.total) {
        this.offset = this.total > this.limit ? this.total - this.limit : 0
      } else if (value === 1) {
        this.offset = 0;
      }
      this.$emit('onChangePage', value);
    },
    buttonColor(i) {
      return i === this.current ? 'primary' : 'default';
    },
  },
};
</script>

<style module></style>
